<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary"
        pill
        @click="createEmergencyScenarioDrill"
        v-if="hasPermission('create_emergency_scenario_drill')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Add New</span>
      </b-button>
    </div>

    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="Site"
              label-for="site"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="emergency_scenario_drills"
        details-td-class="m-1 p-1"
        small
        v-if="hasPermission('read_emergency_scenario_drill')"
        :per-page="0"
      >
        <template #cell(site_data)="row">
          {{
            row.item.site_data ? row.item.site_data.name : ""
          }}
        </template>

        <template #cell(manage)="row">
          <b-button
            variant="success"
            pill
            size="sm"
            class="mr-50"
            @click="editEmergencyScenarioDrill(row.item)"
            v-if="hasPermission('update_emergency_scenario_drill')"
          >
            Edit
          </b-button>

          <b-button
            variant="primary"
            pill
            size="sm"
            class="mr-50"
            @click="downloadImage(row.item.observation_report)"
            v-if="hasPermission('read_emergency_scenario_drill')"
            :disabled="row.item.observation_report ? false:true"
          >
            Download Report
          </b-button>
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
    <CreateEmergencyScenarioDrillModal
      @modalClosed="onModalClosed"
      :key="`create-${createEmergencyScenarioDrillModalCount}`"
    />
    <EditEmergencyScenarioDrillModal
      :emergency_scenario_drill="emergency_scenario_drill"
      @modalClosed="onModalClosed"
      :key="`edit-${editEmergencyScenarioDrillModalCount}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateEmergencyScenarioDrillModal from "@/components/emergency_scenario_drill/CreateEmergencyScenarioDrillModal.vue";
import EditEmergencyScenarioDrillModal from "@/components/emergency_scenario_drill/EditEmergencyScenarioDrillModal.vue";
import util from "@/util.js";
import VueGauge from 'vue-gauge';


export default {
  components: {
    CreateEmergencyScenarioDrillModal,
    EditEmergencyScenarioDrillModal,
    VueSelectPaginated,
    VueGauge,
  },
  data() {
    return {
      fields: [
        { key: "site_data", label: "Site" },
        { key: "name", label: "Drill Name" },
        { key: "scheduled_date", label: "Scheduled Date" },
        { key: "expiry_date", label: "Expiry Date" },
        { key: "manage", label: "Actions" },
      ],
      
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      emergency_scenario_drills: [],
      emergency_scenario_drill: {},
      createEmergencyScenarioDrillModalCount: 0,
      editEmergencyScenarioDrillModalCount: 0,
      searchTypes: [
        { value: 1, name: "Site" },
      ],
      searchType: null,
      sites: [],
      site: "",            
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();
    const sites =  await this.getSitesDDL();
    this.sites = sites.data;
  },
  methods: {
    ...mapActions({
      getSitesDDL: "appData/getSitesDDL",
      getEmergencyScenarioDrills: "appData/getEmergencyScenarioDrills",
    }),
    async search() {
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getEmergencyScenarioDrills({
          pageNumber: this.currentPage,      
          site: this.site,      
        });
        this.emergency_scenario_drills = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    createEmergencyScenarioDrill() {
      this.createEmergencyScenarioDrillModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-emergency-scenario-drill-modal");
      });
    },
    editEmergencyScenarioDrill(emergency_scenario_drill) {
      this.emergency_scenario_drill = emergency_scenario_drill;
      this.editEmergencyScenarioDrillModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-emergency-scenario-drill-modal");
      });
    },
    async removeEmergencyScenarioDrill(emergency_scenario_drill) {
      this.emergency_scenario_drill = emergency_scenario_drill;
      try {
        const res = await this.deleteEmergencyScenarioDrill({
          pk: this.emergency_scenario_drill.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "Emergency Scenario Drill deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    downloadImage(imageUrl) {
      window.open(imageUrl, '_blank');
    },

    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
